export function downloadJson(json: Object, name: string) {
  const jsonString = JSON.stringify(json);

  const blob = new Blob([jsonString], { type: 'application/json' });

  const link = document.createElement('a');

  const url = URL.createObjectURL(blob);
  link.href = url;

  link.download = `${name}.json`;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
